// extracted by mini-css-extract-plugin
export default {"cards":"globalIndicators_cards__Gbvb2","card":"globalIndicators_card__6W0LG"};